// @ts-nocheck

import React from 'react';

import { HideBetSvg, ShowBetSvg } from '../../../../assets/svg/history';
import { __ } from '../../../../i18n/l10n';
import BetslipOptionsItemClick from '../BetslipOptionsItem/BetslipOptionsItemClick';

type BetslipOptionsHideItemProps = {
  className?: string;
  onToggle: () => void;
  isHidden?: boolean;
};

const BetslipOptionsHideItem = ({ className = '', onToggle, isHidden }: BetslipOptionsHideItemProps) => {
  return (
    <BetslipOptionsItemClick
      className={className}
      label={isHidden ? __('Show bet') : __('Hide bet')}
      icon={isHidden ? <ShowBetSvg /> : <HideBetSvg />}
      onClick={onToggle}
      showNewTag
    />
  );
};

export default BetslipOptionsHideItem;
